import React, { useEffect, useState } from "react";
import axios from "axios";

const ServerImages = (props) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const [allPhotos, setAllPhotos] = useState([]);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });
  const [loading, setLoading] = useState(true);
  const imageTypeMap = {
    photoNews: "Photo News",
    speeches: "Speeches",
    passport: "Passport",
  };
  const [currentPage, setCurrentPage] = useState(1);

  const imagesPerPage = 12;
  // SELECTED IMAGE
  const [image, setImages] = useState("");
  const [aspectRatios, setAspectRatios] = useState(
    props.defaultSize || "photoNews",
  );
  const aspectRatioOptions = [
    { value: "", name: "Select the Image Type" },
    { value: "photoNews", name: "Photo News" },
    { value: "speeches", name: "Speeches" },
    { value: "passport", name: "Passport" },
    // { value: "websiteBanner", name: "Website Banner" },
    // { value: "landscape", name: "Landscape Photo" },
  ];
  // FETCH DATA
  useEffect(() => {
    fetchImages(currentPage, aspectRatios);
  }, [currentPage, aspectRatios]);

  const fetchImages = async (page = 1, type = "photoNews") => {
    try {
      setLoading(true);

      const response = await axios.get(`${BASE_URL}server-image`, {
        params: {
          page,
          per_page: 12,
          cropSize: imageTypeMap[type],
        },
      });

      if (response.data.status === 200) {
        setAllPhotos(response.data.allData || []);

        setPagination(
          response.data.pagination || {
            current_page: 1,
            last_page: 1,
          },
        );
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // IMAGE CLICK
  const selectImage = (item) => {
    props.setImage(item.passport);
    props.setCloseImageModal(false);
  };

  // IMAGE RENDER
  // IMAGE RENDER
  const RenderImages = ({ title, data, width, height }) => {
    const totalPages = Math.ceil(data.length / imagesPerPage);

    return (
      <div className="mb-5">
        {/* <h3 className="mb-4">{title}</h3> */}
        <div className="col-md-12 mb-5">
          <select
            className="form-select"
            value={aspectRatios}
            onChange={(e) => {
              setAspectRatios(e.target.value);
              setCurrentPage(1);
            }}
          >
            {aspectRatioOptions.map((item, i) => (
              <option value={item.value} key={i}>
                {item.name}
              </option>
            ))}
          </select>
        </div>
        <div className="row">
          {data.map((item) => (
            <div className="col-md-2 mb-2" key={item.id}>
              <div
                className={`card shadow-sm border-0 h-100 cursor-pointer ${
                  image === item.passport
                    ? "border border-primary border-3"
                    : ""
                }`}
                onClick={() => selectImage(item)}
                style={{
                  cursor: "pointer",
                  transition: "0.3s",
                }}
              >
                {/* IMAGE */}
                <img
                  src={BACKEND_URL + "upload/" + item.passport}
                  alt=""
                  className="card-img-top"
                  style={{
                    height: height,
                    objectFit: "cover",
                    width: width,
                  }}
                />

                {/* BODY */}
                <div className="card-body">
                  <h5>{item.cropSize}</h5>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* PAGINATION */}
        {/* PAGINATION */}
        <div className="d-flex justify-content-center align-items-center mt-4">
          <button
            type="button"
            className="btn btn-primary btn-sm me-2"
            disabled={pagination.current_page === 1}
            onClick={() => setCurrentPage(1)}
          >
            First
          </button>

          <button
            type="button"
            className="btn btn-primary btn-sm me-2"
            disabled={pagination.current_page === 1}
            onClick={() => setCurrentPage((prev) => prev - 1)}
          >
            Prev
          </button>

          <span className="mx-3">
            Page {pagination.current_page} of {pagination.last_page}
          </span>

          <button
            type="button"
            className="btn btn-primary btn-sm me-2"
            disabled={pagination.current_page === pagination.last_page}
            onClick={() => setCurrentPage((prev) => prev + 1)}
          >
            Next
          </button>

          <button
            type="button"
            className="btn btn-primary btn-sm"
            disabled={pagination.current_page === pagination.last_page}
            onClick={() => setCurrentPage(pagination.last_page)}
          >
            Last
          </button>
        </div>
      </div>
    );
  };

  if (loading) {
    return <div className="text-center p-5">Loading...</div>;
  }
  return (
    <div className="container-fluid py-3">
      {aspectRatios === "photoNews" && (
        <>
          {/* PHOTO NEWS */}
          <RenderImages
            title="Photo News"
            data={allPhotos}
            width="100%"
            height="15em"
          />
        </>
      )}

      {aspectRatios === "speeches" && (
        <>
          {/* SPEECHES */}
          <RenderImages
            title="Speeches"
            data={allPhotos}
            width="100%"
            height="15em"
          />
        </>
      )}

      {aspectRatios === "passport" && (
        <>
          {/* Passport */}
          <RenderImages
            title="Passport"
            data={allPhotos}
            width="100%"
            height="15em"
          />
        </>
      )}

      {/* {aspectRatios === "websiteBanner" && (
        <>
          Website Banner
          <RenderImages
            title="Website Banner"
            data={websiteBanner}
            width="100%"
            height="15em"
          />
        </>
      )}

      {aspectRatios === "landscapePhoto" && (
        <>
          Landscape Photo
          <RenderImages
            title="Landscape Photo"
            data={landscapePhoto}
            width="100%"
          />
        </>
      )} */}
    </div>
  );
};

export default ServerImages;
